import ImageDataFetcher from "../../../CommonComponents/ImageDataFetcher/imageDataFetcher"
import "./blogContainer.css";

const BlogContainer=()=>{
    return <ImageDataFetcher contentType={0} collectionName={"Blogs"}/>
}
export default BlogContainer;